// Statistics Action Types

// Get Statistics
export const GET_STATISTICS = "GET_STATISTICS";
export const GET_STATISTICS_SUCCESS = "GET_STATISTICS_SUCCESS";
export const GET_STATISTICS_FAIL = "GET_STATISTICS_FAIL";

// Add Statistics
export const ADD_STATISTICS = "ADD_STATISTICS";
export const ADD_STATISTICS_SUCCESS = "ADD_STATISTICS_SUCCESS";
export const ADD_STATISTICS_FAIL = "ADD_STATISTICS_FAIL";

// Update Statistics
export const UPDATE_STATISTICS = "UPDATE_STATISTICS";
export const UPDATE_STATISTICS_SUCCESS = "UPDATE_STATISTICS_SUCCESS";
export const UPDATE_STATISTICS_FAIL = "UPDATE_STATISTICS_FAIL";

// Delete Statistics
export const DELETE_STATISTICS = "DELETE_STATISTICS";
export const DELETE_STATISTICS_SUCCESS = "DELETE_STATISTICS_SUCCESS";
export const DELETE_STATISTICS_FAIL = "DELETE_STATISTICS_FAIL";

// Set Field Errors
export const SET_STATISTICS_FIELD_ERRORS = "SET_STATISTICS_FIELD_ERRORS";
